import { isMobileDevice } from 'src/components/player/src/utils/Utils';
import { getRegisteredUserSettings } from 'src/services/apiRequests/LandingPage/registeredUserFlow';
import { Countrylist } from 'src/services/responseTypes/singleLaunchResponse';
import { UsersPreferenceData } from 'src/store/interface';

import { getCookie, getLocalStorage } from './browserStorageHandler';
import { checkKidsCard, isServer, parseJsonObject } from './common';
import { ASSET_TYPE } from './constants/AppConstants';
import { Commerce } from './constants/CommerceConstants';
import { DISPLAY_LANGUAGE_COOKIE } from './constants/cookieConstants';
import { GUEST_WATCH_HISTORY } from './constants/localStorageConstants';
import {
  DisplayLanguage,
  PARENTAL_CONSTANTS,
  UserTypes
} from './constants/stringConstants';
import { CHANNEL_GUIDE_CONSTANTS } from './constants/utilConstants';
import { getAutomaticAgeRating } from './VideoPlayerUtils/Utils';
import { BestOffering } from '../services/responseTypes/plansMetaDataResponse';

export const getContentType = ({
  asset_type: assetType,
  asset_subtype: assetSubtype
}: any) => {
  switch (assetType) {
    case ASSET_TYPE.Movie:
      return assetSubtype === 'video' ? 'video' : 'movie';
    case ASSET_TYPE.Episode:
      return 'episode';
    case ASSET_TYPE.Channel:
      return 'livetv';
    default:
      return '';
  }
};
// function to check if it is tvod
export const checkIsTvod = (businessType: string) => {
  if (businessType) {
    return (
      businessType.toLowerCase() === 'tvod' ||
      businessType.toLowerCase() === 'tvod_downloadable' ||
      businessType.toLowerCase() === 'tvod_premium'
    );
  }
};

// Business type check for getting premium content
export const businessType = (
  type: string,
  billingType: string,
  isEduauraa = false
) => {
  if (
    type === 'premium' ||
    type === 'premium_downloadable' ||
    billingType === 'club' ||
    billingType === 'premium' ||
    isEduauraa
  ) {
    return true;
  }
  return false;
};

export function checkDeviceOrientaion() {
  let orientation = '';
  if (!isServer()) {
    if (window.matchMedia(Commerce.ORIENTATION_LANDSCAPE).matches) {
      orientation = Commerce.LANDSCAPE;
    } else if (window.matchMedia(Commerce.ORIENTATION_PORTRATIT).matches) {
      orientation = Commerce.PORTRAIT;
    }
  }
  return orientation;
}

// eslint-disable-next-line cyclomatic-complexity/zee-codeBlockComplexity
export function deviceOrientation() {
  let deviceOrientationVal = '';
  if (!isServer()) {
    const orientation = checkDeviceOrientaion();
    const isMobile = isMobileDevice();
    if (isMobile) {
      if (orientation === Commerce.LANDSCAPE) {
        deviceOrientationVal = Commerce.MOBILE_LANDSCAPE;
      } else if (orientation === Commerce.PORTRAIT) {
        deviceOrientationVal = Commerce.MOBILE_PORTRAIT;
      }
    } else {
      if (orientation === Commerce.LANDSCAPE) {
        deviceOrientationVal = Commerce.DESKTOP_LANDSCAPE;
      } else if (orientation === Commerce.PORTRAIT) {
        deviceOrientationVal = Commerce.DESKTOP_PORTRAIT;
      }
    }
  }
  return deviceOrientationVal;
}

export function isFullScreen() {
  return !isServer() && window?.videoPlayer?.isFullscreen();
}

export const getsubscribeToPremium = (
  country: string,
  bestOfferingPlan?: BestOffering
) => {
  const { messages = {} } = window.translationsAndConfigs || {};
  let premiumMessage = '';
  if (country.toLowerCase() !== 'in') {
    premiumMessage = bestOfferingPlan
      ? `${messages.subscribeToPremium_Global} @ ${bestOfferingPlan.actual_price} ${bestOfferingPlan.currency}`
      : messages.subscribeToPremium_Global;
  } else {
    premiumMessage = messages.subscribeToPremium;
  }
  return premiumMessage;
};

export const getContentSpecification = (
  assetType: number,
  assetSubtype: string
) => {
  let contentSpecification = 'N/A';
  if (assetType === ASSET_TYPE.Movie) {
    contentSpecification = assetSubtype;
  }
  if (assetType === ASSET_TYPE.Episode || assetType === ASSET_TYPE.TvShow) {
    contentSpecification = 'video';
  } else if (assetType === ASSET_TYPE.Channel) {
    contentSpecification = CHANNEL_GUIDE_CONSTANTS.CHANNEL;
  }
  return contentSpecification;
};

export const getTopCategory = (data: any) => {
  let topCategory = 'N/A';
  const isKids = checkKidsCard(data.genre || data.genres);
  if (data && (data.asset_type || data.assetType) === 0) {
    if (
      (data.asset_subtype || data.assetSubType) &&
      ((data.asset_subtype && data.asset_subtype.indexOf('movie') > -1) ||
        (data.assetSubType && data.assetSubType.indexOf('movie') > -1))
    ) {
      topCategory = isKids ? 'Kids Movies' : 'Movie';
    } else if (
      (data.asset_subtype || data.assetSubType) &&
      ((data.asset_subtype && data.asset_subtype.indexOf('video') > -1) ||
        (data.assetSubType && data.assetSubType.indexOf('video') > -1))
    ) {
      const genres = data.genre || data.genres;
      if (
        genres.filter((item: any) => item.id.toLowerCase().includes('news'))
          .length
      ) {
        topCategory = isKids ? 'Kids News' : 'News';
      } else if (
        genres.filter((item: any) => item.id.toLowerCase().includes('music'))
          .length
      ) {
        topCategory = isKids ? 'Kids Music' : 'Music';
      } else {
        // if not originals
        topCategory = isKids ? 'Kids Video' : 'Video';
      }
    } else {
      topCategory = isKids ? 'Kids Movies' : 'Movie';
    }
  } else if (data && (data.asset_type || data.assetType) === 1) {
    const tvshowInfo =
      data &&
      (data.tvshow ||
        data.tvshows ||
        data.tvshow_detail ||
        data.tvshow_details);
    if (
      tvshowInfo &&
      (tvshowInfo.asset_subtype || tvshowInfo.assetSubType) &&
      ((tvshowInfo.asset_subtype &&
        tvshowInfo.asset_subtype.indexOf('original') > -1) ||
        (tvshowInfo.assetSubType &&
          tvshowInfo.assetSubType.indexOf('original') > -1))
    ) {
      topCategory = isKids ? 'Kids Original' : 'Original';
    } else {
      topCategory = isKids ? 'Kids Tv Show' : 'Tv Show';
    }
  } else if (data && (data.asset_type || data.assetType) === 6) {
    topCategory = isKids
      ? `Kids ${data.asset_subtype || data.assetSubType}`
      : data.asset_subtype || data.assetSubType;
  } else if (data && (data.asset_subtype || data.assetSubType)) {
    topCategory = data.asset_subtype || data.assetSubType;
  }
  return topCategory;
};

export const parentaPinHelper = async (
  settingsData: UsersPreferenceData,
  userType: string,
  InitialData: Countrylist,
  parentalPinStatus: boolean
) => {
  let settingsValue = settingsData;
  let isParentalControlSet = false;
  let parentalControlValue;
  let parentalControlPin;
  try {
    if (userType !== UserTypes.GUEST && !settingsData?.parental_control_v2) {
      const locale =
        getCookie(DISPLAY_LANGUAGE_COOKIE) || DisplayLanguage.ENGLISH;
      settingsValue = await getRegisteredUserSettings(locale, InitialData);
    }
  } catch (err) {
    console.error('settingsValue is null or empty: ', err);
  }

  if (
    userType !== UserTypes.GUEST &&
    settingsValue &&
    Object.keys(settingsValue).length &&
    settingsValue.parental_control_v2 &&
    settingsValue.parental_control_v2 !== '{}'
  ) {
    const parentalData = parseJsonObject(settingsValue.parental_control_v2);
    const { age_rating } = parentalData;
    isParentalControlSet =
      parentalPinStatus &&
      age_rating &&
      age_rating !== '' &&
      age_rating !== 'undefined' &&
      age_rating !== PARENTAL_CONSTANTS.GROUP_NR;
    parentalControlValue = isParentalControlSet ? age_rating : '';
    parentalControlPin = isParentalControlSet ? parentalData.pin : '';
  }
  /* For Automatic pin setting */
  const countryList = InitialData;
  const mandatoryAgeRating = getAutomaticAgeRating(countryList);
  if (parentalPinStatus && (mandatoryAgeRating || mandatoryAgeRating === 0)) {
    if (
      userType !== UserTypes.GUEST &&
      settingsValue &&
      Object.keys(settingsValue).length &&
      settingsValue.parental_control_v2
    ) {
      const parentalData = parseJsonObject(settingsValue.parental_control_v2);
      const { age_rating } = parentalData;
      isParentalControlSet =
        age_rating &&
        age_rating !== '' &&
        age_rating !== 'undefined' &&
        age_rating !== PARENTAL_CONSTANTS.GROUP_NR;
      if (isParentalControlSet) {
        parentalControlValue =
          age_rating < mandatoryAgeRating ? age_rating : mandatoryAgeRating;
        parentalControlPin = parentalData.pin;
      } else {
        parentalControlValue = mandatoryAgeRating;
        parentalControlPin = '';
        isParentalControlSet = true;
      }
    } else {
      parentalControlValue = mandatoryAgeRating;
      parentalControlPin = '';
      isParentalControlSet = true;
    }
  }
  return { isParentalControlSet, parentalControlValue, parentalControlPin };
};

export const getWatchHistoryDeatilsForGuestUser = (data: {
  assetDetails: { id: any };
  watchHistoryDetails: { id: any; play_date: string; played_duration: any };
}) => {
  const localStorageWatchHistory = getLocalStorage(GUEST_WATCH_HISTORY);
  if (localStorageWatchHistory) {
    const parseLocalWatchHistory = JSON.parse(localStorageWatchHistory);
    if (parseLocalWatchHistory && parseLocalWatchHistory.length) {
      const filterMovie = parseLocalWatchHistory.filter(
        (item: { id: any }) => data.assetDetails.id === item.id
      );
      if (filterMovie && filterMovie.length) {
        const data = {
          id: filterMovie[0].id,
          play_date: '',
          played_duration: filterMovie[0].played_duration
        };
        return data;
      }
    }
  }
  return null;
};
